import request from '../../utils/request';
const querystring = require('querystring')
 
 
//获取菜单
export const getItem = query => {   
    var list = request({
        url: 'rootItems/getItem.do', 
        method: 'post',
        data:  querystring.stringify(query), 
    }); 
    return list; 
};

